var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWebDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150.05 112.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 18.34,
    x2: 105.88,
    y1: 15.49,
    y2: 99.93
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#315050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42ACA5"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(.70710678 .70710678 -.70710678 .70710678 44.73 -20.85)",
    x1: 18.38,
    x2: 105.92,
    xlinkHref: "#a",
    y1: 15.44,
    y2: 99.89
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 12.68,
    x2: 100.22,
    xlinkHref: "#a",
    y1: 21.35,
    y2: 105.8
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(.70710678 .70710678 -.70710678 .70710678 32.49 -8.62)",
    x1: 12.64,
    x2: 100.18,
    xlinkHref: "#a",
    y1: 21.4,
    y2: 105.84
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 21.88,
    x2: 109.42,
    xlinkHref: "#a",
    y1: 11.81,
    y2: 96.26
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 22.04,
    x2: 109.58,
    xlinkHref: "#a",
    y1: 11.65,
    y2: 96.1
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -5.47,
    x2: 82.06,
    xlinkHref: "#a",
    y1: 40.17,
    y2: 124.62
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 26.49,
    x2: 114.02,
    xlinkHref: "#a",
    y1: 7.04,
    y2: 91.49
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -7.84,
    x2: 79.7,
    xlinkHref: "#a",
    y1: 42.62,
    y2: 127.07
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -7.53,
    x2: 80.01,
    xlinkHref: "#a",
    y1: 42.3,
    y2: 126.75
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 14.53,
    x2: 102.07,
    xlinkHref: "#a",
    y1: 19.43,
    y2: 103.88
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 5.36,
    x2: 92.89,
    xlinkHref: "#a",
    y1: 28.94,
    y2: 113.39
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 23.92,
    x2: 111.46,
    xlinkHref: "#a",
    y1: 9.7,
    y2: 94.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h150.05v112.2h-150.05z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m42.34 53.6v-4.12l11.1-.01v-11.1h4.12v15.22z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m45.47 33.39h4.12v20.34h-4.12z",
    fill: "url(#b)",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -16.88 46.37)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m20.85 40.21h-4.12v-15.22h15.22v4.12h-11.1z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m24.59 24.58h4.12v20.67h-4.12z",
    fill: "url(#d)",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -16.88 29.07)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m101.33 69h-4.12v-56.81a.6.6 0 0 0 -.6-.6h-91.83a.6.6 0 0 0 -.6.6v56.81h-4.12v-56.81a4.72 4.72 0 0 1 4.72-4.72h91.83a4.72 4.72 0 0 1 4.72 4.72z",
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m57.36 62.27h-48.67v-46.05h83.92v30h-4.13v-25.88h-75.68v37.82h44.56z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m57.36 82.54h-52.12a5.59 5.59 0 0 1 -5.24-5.38v-10.25h57.36v4.09h-53.24v6.13a1.67 1.67 0 0 0 1.12 1.26h52.12z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m96.85 82.54h-5v-4.12h5c.14 0 .46-.47.46-1.12v-6.3h-5.45v-4.09h9.57v10.39c0 2.58-1.71 5.24-4.58 5.24z",
    fill: "url(#h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m36.23 95.08-1.64-3.78c1.06-.46 1.88-.84 2.32-1.08l.14-.08c.13-.07.24-.12.33-.18a6.92 6.92 0 0 0 .26-1 31.78 31.78 0 0 0 .17-5.1c0-1.31 0-2.55 0-3.45l4.11.34c-.06.7-.05 1.84 0 3a32.36 32.36 0 0 1 -.25 6c-.49 2.46-1.09 3.16-2.64 4l-.14.08c-.56.31-1.45.73-2.66 1.25z",
    fill: "url(#i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m32.75 90.97h24.62v4.12h-24.62z",
    fill: "url(#j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m88.79 108.48h-23.89a3.77 3.77 0 0 1 -3.76-3.76v-50.34a3.77 3.77 0 0 1 3.76-3.76h23.89a3.77 3.77 0 0 1 3.77 3.76v50.34a3.77 3.77 0 0 1 -3.77 3.76zm-23.53-4.12h23.18v-49.63h-23.18z",
    fill: "url(#k)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m63.78 95.85h26.13v4.12h-26.13z",
    fill: "url(#l)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m63.78 58.7h26.13v4.12h-26.13z",
    fill: "url(#m)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebDevelopment);
export default __webpack_public_path__ + "static/media/icon_web-development.edfeef8ae54ffa4be5b43ef4798ee88b.svg";
export { ForwardRef as ReactComponent };